import router from "@/router";

export const auth = {
    state: {
        user: {},
        token: '',
        loggedIn: false
    },
    actions: {
        logoutAction({ commit }) {
            commit('destroyUser');

            localStorage.setItem('token', '')
            localStorage.setItem('user', {})
            localStorage.setItem('loggedIn', false)

            router.push('/')
        },
        setUserAction({ commit }, payload) {
            commit('setUser', payload);

            localStorage.setItem('token', payload.token)
            localStorage.setItem('user', JSON.stringify(payload.user))
            localStorage.setItem('loggedIn', true)

            router.push('/home')
        },
        loadStoredState({ commit }) {
            const loggedIn = JSON.parse(localStorage.getItem("loggedIn"));
            
            if (loggedIn) {
                const token = localStorage.getItem("token");
                const user = JSON.parse(localStorage.getItem("user"));
                commit('setUser', {'token': token, 'user': user}) 
            } else {
                commit('destroyUser') 
            }
        }
    },
    mutations: {
        destroyUser(state) {
            state.loggedIn = false;
            state.user = null;
            state.token = null;
        },
        setUser(state, payload) {
            state.loggedIn = true;
            state.user = payload.user;
            state.token = payload.token;
        },
    }
};
